
const aaa = [
	{
        path: "templateList",
        component: () => import("@/views/template/templateList.vue"),
        meta:{title:'合同模版'},
    },
]
export default aaa;